import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { BaseModal } from 'components/UI';
import { Button, Box, Typography } from '@material-ui/core';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import i18n from 'i18n-js';
import { useStyles } from './PendingReservationModal.styled';
import { ReservationsActions } from 'state/modules/reservations';

const PendingReservationModal = ({ id, open, onClose }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { reservationLoading } = useSelector((state) => state.reservations);

  const handleClose = () => {
    if (!reservationLoading) {
      onClose();
    }
  };

  const handleBypassConfirm = async () => {
    const result = await dispatch(
      ReservationsActions.updateReservation(id, { action: 'FORCE_CONFIRM' })
    );
    if (result?.payload?.status && result.payload.status !== 'PENDING') {
      onClose();
    }
  };

  return (
    <BaseModal
      open={open}
      size="md"
      title=""
      hasHeader={true}
      hasFooter={false}
      enableCloseButton={true}
      handleClick={handleClose}
      bodyClassName={classes.modalBody}
    >
      <Box className={classes.container}>
        <AssignmentTurnedInIcon className={classes.icon} />

        <Typography variant="h5" className={classes.title}>
          {i18n.t('reservations.pending_action_required')}
        </Typography>

        <Typography className={classes.description}>
          <span dangerouslySetInnerHTML={{ __html: i18n.t('reservations.pending_description') }} />
        </Typography>

        <ul className={classes.list}>
          <li>
            <Typography>
              <strong>{i18n.t('reservations.pending_bullet_1_title')}</strong>
              {i18n.t('reservations.pending_bullet_1_desc')}
            </Typography>
          </li>
          <li>
            <Typography>
              <strong>{i18n.t('reservations.pending_bullet_2_title')}</strong>
              {i18n.t('reservations.pending_bullet_2_desc')}
            </Typography>
          </li>
        </ul>

        <Box className={classes.actionsContainer}>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleClose}
            className={classes.cancelButton}
            disabled={reservationLoading}
          >
            {i18n.t('reservations.leave_pending')}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleBypassConfirm}
            className={classes.confirmButton}
            disabled={reservationLoading}
          >
            {i18n.t('reservations.bypass_and_confirm')}
          </Button>
        </Box>
      </Box>
    </BaseModal>
  );
};

PendingReservationModal.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PendingReservationModal;
